import React from 'react';
import { Avatar } from 'antd';
import { imageUrl } from 'pages/star-shared/utils';
import { colors } from 'theme/tokens';
import UserAvatar from 'components/user-avatar';
import { CLASS_STYLE, PRIORITY_STYLE, STATUS_STYLE, initials } from './utils';

interface PillProps {
  color: string;
  bg: string;
  children: React.ReactNode;
  title?: string;
  style?: React.CSSProperties;
}

/** Nhãn nhỏ bo tròn (không dùng antd Tag để màu khớp bộ màu app). */
export const Pill = ({ color, bg, children, title, style }: PillProps) => (
  <span
    title={title}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      padding: '1px 8px',
      borderRadius: 999,
      fontSize: 12,
      lineHeight: '20px',
      fontWeight: 600,
      whiteSpace: 'nowrap',
      color,
      background: bg,
      ...style,
    }}
  >
    {children}
  </span>
);

export const StatusPill = ({ status }: { status: string }) => {
  const s = STATUS_STYLE[status] || STATUS_STYLE.OPEN;
  return (
    <Pill color={s.color} bg={s.bg}>
      {s.label}
    </Pill>
  );
};

export const PriorityPill = ({ priority }: { priority: string }) => {
  if (!priority || priority === 'NORMAL') return null;
  const s = PRIORITY_STYLE[priority];
  return (
    <Pill color={s.color} bg={s.bg}>
      {s.label}
    </Pill>
  );
};

export const ClassPill = ({ value, label }: { value?: string | null; label?: string | null }) => {
  if (!value) return null;
  const s = CLASS_STYLE[value] || CLASS_STYLE.PUBLIC;
  return (
    <Pill color={s.color} bg={s.bg}>
      {label || value}
    </Pill>
  );
};

/** Người: trống ảnh → ảnh gà mặc định. `group` (Trang, nhóm): trống ảnh → chữ cái. */
export const PersonAvatar = ({
  name,
  avatar,
  size = 36,
  group,
}: {
  name?: string | null;
  avatar?: string | null;
  size?: number;
  group?: boolean;
}) => {
  if (!group) return <UserAvatar size={size} src={avatar} style={{ flex: 'none' }} />;
  const src = avatar ? imageUrl(avatar) : undefined;
  return (
    <Avatar
      size={size}
      src={src}
      style={{
        flex: 'none',
        background: src ? undefined : colors.accentSoft,
        color: colors.accentDeep,
        fontWeight: 700,
        fontSize: Math.max(11, Math.round(size * 0.36)),
      }}
    >
      {initials(name)}
    </Avatar>
  );
};
